module.exports = "data:image/gif;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvaW1nL3dlY2hhdC4xMGY0YzZhLmdpZiI7DQoNCg0KLy8vLy8vLy8vLy8vLy8vLy8vDQovLyBXRUJQQUNLIEZPT1RFUg0KLy8gLi9zcmMvYXNzZXRzL2ltYWdlcy93ZWNoYXQuZ2lmDQovLyBtb2R1bGUgaWQgPSByWUlsDQovLyBtb2R1bGUgY2h1bmtzID0gMjU="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wechat.gif
// module id = rYIl
// module chunks = 49